import { URL_BASE_PHP_8 } from 'constants/urls';

export const URL_INGRESAR_AIGGO_MB = `${URL_BASE_PHP_8}api/v1/auth/hash/create-hash-with-app`;
